import Table from './container';

export default Table;
